import { Injectable } from '@angular/core';

import { Field } from '@site-mate/dashpivot-shared-library';

import { GlobalApiService } from 'app/global-api/global-api.service';

@Injectable({
  providedIn: 'root',
})
export class SamService {
  constructor(private readonly sitemateGlobalApiService: GlobalApiService) {}

  listTasks(appId: string) {
    return this.sitemateGlobalApiService.listSamTasks(appId);
  }

  executeTask(taskId: string, formItem: Field, files: string[]) {
    return this.sitemateGlobalApiService.executeSamTask(taskId, { formItem, files });
  }
}
